import { useState } from "react";
import toast from "react-hot-toast";
import { saveSubscriptionNotes } from "../../../services/saveSubscriptionNotes";
import NoteEditor from "../../notes/NoteEditor";
import ViewNotes from "./ViewNotes";
import { usePermissions } from "../../../context/PermissionsContext";

const ClientServiceNotes = ({
    clientService,
    setClientService,
    loggedInEmployee,
}) => {
    const { can, permissionsLoading } = usePermissions();
    const canReadServices =
        !permissionsLoading && can("client_services.read");
    const canWriteServices =
        !permissionsLoading && can("client_services.write");
    const [editNotes, setEditNotes] = useState(false);

    async function saveNotes(notesAndMentions) {
        if (!canWriteServices) return;

        const response = await saveSubscriptionNotes(clientService.id, {
            notes: notesAndMentions.notes,
            mentionedEmployeesIds: notesAndMentions.mentionedEmployeesIds,
        });

        if (!response.success) {
            return toast.error(response.message);
        }

        const newNotes = notesAndMentions.notes;
        toast.success(response.data.message);
        setClientService({
            ...clientService,
            notes: newNotes,
        });
    }

    if (!canReadServices) return null;

    return (
        <div className="w-full">
            {editNotes ? (
                <>
                    <NoteEditor
                        label="Permanent notes"
                        notes={clientService.notes}
                        saveNotes={saveNotes}
                        setEditNotes={setEditNotes}
                        loggedInEmployee={loggedInEmployee}
                    />
                    {/*  <EditNotes
                        label="Permanent notes"
                        notes={clientService.notes}
                        saveNotes={saveNotes}
                        setEditNotes={setEditNotes}
                    /> */}
                </>
            ) : (
                <ViewNotes
                    label="Permanent notes"
                    notes={clientService.notes}
                    setEditNotes={setEditNotes}
                    canEdit={canWriteServices}
                />
            )}
        </div>
    );
};

export default ClientServiceNotes;
